import format from '_shared_/plugins/format';

const mutations = {
  SET_SUMMARY(state, payload) {
    state.summaryModuleData = {
      headline: payload.BumperHeadline,
      description: payload.BumperDescription,
      fundAtNav: format.formatHelpers.percent(0),
      managerCount: payload.ManagerCount,
      fundAssets: format.formatHelpers.price(payload.FundAssetsMillions, 1),
      expenseRatioPercentGross: format.formatHelpers.number(payload.ExpenseRatioGross, 2),
      priceAtNav: format.formatHelpers.price(payload.NAVPriceCurrent),
      navAsOfDate: format.formatHelpers.shortDate(payload.NAVPriceCurrentAsOfDate),
      expenseRatioPercentNet: format.formatHelpers.rawPercent(payload.ExpenseRatioNet, 2)
    };
  }
};

const getters = {
  getSummaryModuleData: state => state.summaryModuleData
};

const state = {
  summaryModuleData: null
};

export default {
  state,
  getters,
  mutations
};
